import clsx from 'clsx';
import type { FC } from 'react';
import { SafeHtml } from '@headstartwp/core/react';

import styles from './styles.module.css';

export const GalleryCaption: FC<{ caption?: string; className?: string }> = ({
	caption,
	className,
}) => {
	if (!caption) {
		return null;
	}

	return (
		<figcaption className={clsx(styles.caption, className)}>
			<SafeHtml html={caption} />
		</figcaption>
	);
};
